const BLOG_POSTS = [
  {
    id: "1",
    date: "December 4, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/programmer.png?raw=true",
    title: "What is the Brute force approach?",
    link: "https://medium.com/@hrusikesh251.nalanda/what-is-the-brute-force-approach-a6abcf95f0af",
  },
  {
    id: "2",
    date: "December 3, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/cloud.png?raw=true",
    title: "What is cloud computing and its types ?",
    link: "https://medium.com/@hrusikesh251.nalanda/what-is-cloud-computing-and-its-types-c1b36455ce0",
  },
  {
    id: "3",
    date: "November 20, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "What are Ajax and Web API in Javascript?",
    link: "https://medium.com/@hrusikesh251.nalanda/what-are-ajax-and-web-api-in-javascript-218f33ceb404",
  },
  {
    id: "4",
    date: "November 13, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/golang_logo.png?raw=true",
    title: "How to write and read a file in Golang using ioutil package?",
    link: "https://medium.com/@hrusikesh251.nalanda/how-to-write-and-read-a-file-in-golang-using-ioutil-package-afd064020954",
  },
  {
    id: "5",
    date: "November 12, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "Array method tricks in javascript 2023.",
    link: "https://medium.com/@hrusikesh251.nalanda/array-method-tricks-in-javascript-2023-de7972dacc50",
  },
  {
    id: "6",
    date: "November 21, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/golang_logo.png?raw=true",
    title: "What is a pointer in Go?",
    link: "https://medium.com/@hrusikesh251.nalanda/what-is-a-pointer-in-go-68df681aad2e",
  },
  {
    id: "7",
    date: "November 26, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title:
      "Write a function that accepts a string. The function should capitalize the first letter of each word in the string and return the result.",
    link: "https://medium.com/@hrusikesh251.nalanda/write-a-function-that-accepts-a-string-f1032fb76c03",
  },
  {
    id: "8",
    date: "December 9, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/artificial-intelligence.png?raw=truehttps://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "ChatGPT OpenAI By Elon Musk.",
    link: "https://medium.com/@hrusikesh251.nalanda/chatgpt-openai-by-elon-musk-7edc841a98da",
  },
];

export default BLOG_POSTS;
